export default function DashboardLinkIcon() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 16.2497H17.25M4.5 11.75L15 1.25M15 1.25V10.625M15 1.25H5.625"
        stroke="#AFBACA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
